import { BusinessAccountsSearchParams, privateApi, publicApi } from 'services';
import { BusinessAccount, BusinessAccountType, CreateTrialBusinessAccount } from './types';
import { privateApiWithRouteLeavingCancelation } from '../ApiService/ApiServiceWithRouteLeavingCancelation';

const fetchBusinessAccount = async (businessAccountId: string): Promise<BusinessAccount> =>
    privateApi.get<BusinessAccount>(`business-accounts/${businessAccountId}`);

const fetchBusinessAccounts = async (params?: BusinessAccountsSearchParams | null): Promise<BusinessAccount[]> =>
    privateApi.get<BusinessAccount[]>(`business-accounts`, params ? { params } : null);

const createBusinessAccount = async (data: any): Promise<BusinessAccount> =>
    privateApi.post<BusinessAccount>('business-accounts', data);

const createTrialBusinessAccount = async (data: CreateTrialBusinessAccount): Promise<BusinessAccount> =>
    privateApi.post<BusinessAccount>('business-accounts/trial', data);

const updateBusinessAccount = async (businessAccountId: string, businessAccount: any): Promise<any> =>
    privateApi.patch<any>(`business-accounts/${businessAccountId}`, businessAccount);

const updateBusinessAccountLogo = async (businessAccountId: string, formData: FormData): Promise<[]> =>
    privateApi.postMultipart<[]>(`business-accounts/${businessAccountId}/logo`, formData);

const updateBusinessAccountType = async (
    businessAccountId: string,
    businessAccountType: BusinessAccountType,
): Promise<void> =>
    privateApi.put<void>(`business-accounts/${businessAccountId}/type`, {
        type: businessAccountType,
    });

const updateBusinessAccountSalesforceId = async (businessAccountId: string, salesforceId: string): Promise<void> =>
    privateApi.put(`business-accounts/${businessAccountId}/salesforce-id`, { salesforceAccountId: salesforceId });

const updateAdvertisementCreditLine = async (
    businessAccountId: string,
    advertisementCreditLine: string,
): Promise<void> =>
    privateApi.put(`business-accounts/${businessAccountId}/credit-line`, {
        advertisementCreditLine,
    });

export const BusinessAccountGateway = {
    fetchBusinessAccount,
    fetchBusinessAccounts,
    createBusinessAccount,
    createTrialBusinessAccount,
    updateBusinessAccount,
    updateBusinessAccountLogo,
    updateBusinessAccountType,
    updateBusinessAccountSalesforceId,
    updateAdvertisementCreditLine,
};

const cancelableFetchBusinessAccount = async (businessAccountId: string): Promise<BusinessAccount> =>
    privateApiWithRouteLeavingCancelation.getWithAbortControl<BusinessAccount>(
        `business-accounts/${businessAccountId}`,
    );

const cancelableFetchBusinessAccounts = async (
    params?: BusinessAccountsSearchParams | null,
): Promise<BusinessAccount[]> =>
    privateApiWithRouteLeavingCancelation.getWithAbortControl<BusinessAccount[]>(
        `business-accounts`,
        params ? { params } : null,
    );

export const CancelableBusinessAccountGateway = {
    cancelableFetchBusinessAccount,
    cancelableFetchBusinessAccounts,
};
